import { render, staticRenderFns } from "./ServerInfoCollect.vue?vue&type=template&id=421313e8&"
import script from "./ServerInfoCollect.vue?vue&type=script&lang=js&"
export * from "./ServerInfoCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports